import type { DevicePresence } from '@kidshub/contracts';

/**
 * How a tablet's presence is drawn on the "now" card.
 *
 * Sage and pulsing only while something is actually happening on the screen;
 * amber for a video that is open but still; muted for everything else. The
 * colours mean what `ui/tokens.ts` says they mean, and "watching" no longer
 * glows over a tablet that has been closed for an hour.
 */
export const PRESENCE_PILL: Record<DevicePresence, 'pill-live' | 'pill-pause' | 'pill-rest'> = {
  WATCHING: 'pill-live',
  PLAYING_GAME: 'pill-live',
  VIDEO_PAUSED: 'pill-pause',
  BROWSING: 'pill-rest',
  BACKGROUND: 'pill-rest',
  APP_CLOSED: 'pill-rest',
  OFFLINE: 'pill-rest',
};

/** Whether the tablet is out of reach, so the card says when it was last heard from. */
export const isPresenceAway = (presence: DevicePresence): boolean =>
  presence === 'APP_CLOSED' || presence === 'OFFLINE';
